import paper from "paper";
import {useEffect, useRef, useState} from "react";
import {createConnection} from "../../services/fetch";
import {getStroke} from "perfect-freehand";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {RgbaStringColorPicker} from "react-colorful";
import Test from "../projector/test";


const MyForm = (props) => {

    const svgF=useRef(null);
    const downl= ()=>{
        const svgData = new XMLSerializer().serializeToString(svgF.current);
        const svgBlob = new Blob([svgData], {type: 'image/svg+xml;charset=utf-8'});

        /* */
        const recording_url = URL.createObjectURL(svgBlob);
        const a = document.createElement('a');
         a.style = "display: none;";
         a.href = recording_url;
         a.download = dia.name+'.svg';
         document.body.appendChild(a);
         a.click();

    }




    const getHighLigtt = (strokeData, offset = 1) => {
        const result = [];
        let currentLine = [];
        let currentLine1 = [];



if(strokeData.length>1){
    const la = new paper.Path({segments:strokeData.map((point, i) => new paper.Point(point.x,point.y))})
    la.smooth({type: 'continuous'})
   // la.simplify(6)
   // la.smooth({type: 'continuous'})
    la.segments.map((point1, i) => {
const point=point1.point;
        const nor = (la.getNormalAt(la.getOffsetOf(point)))
        const a = new paper.Point(point.x + nor.x * offset/2 , point.y + nor.y * offset/2  );
        currentLine.push(a);
        currentLine1.push(new paper.Point(point.x - nor.x * offset/2, point.y - nor.y * offset/2 ));
})
    currentLine.reverse()

    return new paper.Path({closed:true,segments:currentLine.concat(currentLine1)})
}else{
    return new paper.Path.RegularPolygon(new paper.Point(strokeData[0].x,strokeData[0].y), 4, offset);

}


        // Catch any remaining points if the array ended on a valid streak



    }
    const getCLByWidth = (strokeData, minWidth = 5, maxWidth = 8, offset = 1) => {
        const result = [];
        let currentLine = [];
        let currentLine1 = [];

        strokeData.map((point, i) => {

            if (point.pressure >= minWidth && point.pressure <= maxWidth) {
                // Point is within the range, add to the current continuous segment
                if (currentLine.length == 0 && i > 0) {
                    const b = strokeData[i - 1]
                    currentLine.push(new paper.Point(b.x, b.y));
                    currentLine1.push(new paper.Point(b.x, b.y));
                }
                const a = new paper.Point(point.x + point.nor.x * offset * point.pressure * .1, point.y + point.nor.y * offset * point.pressure * .1);
                currentLine.push(a);
                currentLine1.push(new paper.Point(point.x - point.nor.x * offset * point.pressure * .1, point.y - point.nor.y * offset * point.pressure * .1));

            } else {
                // Point is out of bounds. If we have accumulated points,
                // save the current line and start a new one.
                if (currentLine.length > 0) {
                    if (i < strokeData.length - 1) {
                        const b = strokeData[i + 1]
                        currentLine.push(new paper.Point(b.x, b.y));
                        currentLine1.push(new paper.Point(b.x, b.y));
                    }
                    result.push(currentLine);
                    result.push(currentLine1);
                    currentLine = [];
                    currentLine1 = [];
                }
            }
        })

        // Catch any remaining points if the array ended on a valid streak
        if (currentLine.length > 0) {
            result.push(currentLine);
            result.push(currentLine1);
        }

        return result;
    }
    const getCanvasPoint = (event) => {
        const rect = canvasRef.current.getBoundingClientRect();

        return {
            x: event.clientX - rect.left,
            y: event.clientY - rect.top,
        };
    };

    const handleCanvasPointerDown = (event) => {
        const point = getCanvasPoint(event);

        const initialSelection = {
            x: point.x,
            y: point.y,
            width: 160,
            height: 100,
        };

        setSelection(initialSelection);
    };

    const handleSelectionPointerDown = (event) => {
        event.stopPropagation();

        dragRef.current = {
            type: 'move',
            startX: event.clientX,
            startY: event.clientY,
            initial: selection,
        };
    };

    const handleResizePointerDown = (event) => {
        event.stopPropagation();

        dragRef.current = {
            type: 'resize',
            startX: event.clientX,
            startY: event.clientY,
            initial: selection,
        };
    };

    const handlePointerMove = (event) => {
        if (!dragRef.current) return;

        const {type, startX, startY, initial} = dragRef.current;

        const dx = event.clientX - startX;
        const dy = event.clientY - startY;

        if (type === 'move') {
            setSelection({
                ...initial,
                x: initial.x + dx,
                y: initial.y + dy,
            });


        }

        if (type === 'resize') {
            setSelection({
                ...initial,
                width: Math.max(20, initial.width + dx),
                height: Math.max(20, initial.height + dy),
            });
        }


        if (stroke && lln) {
            const ar = []
            lln.segments.map((s, ix) => {
                if (s.point.x > selection.x - lln.data.sizen[2] && s.point.x < selection.x - lln.data.sizen[2] + selection.width && s.point.y > selection.y - lln.data.sizen[3] && s.point.y < selection.y - lln.data.sizen[3] + selection.height) {

                    ar.push([ix, new paper.Segment([s.point.x + lln.data.sizen[2], s.point.y + lln.data.sizen[3]])]);
                }
            })
            const tl = paper.project.activeLayer.children[1].data

            tl.tLine.removeSegments()
            tl.tLine.addSegments(ar.map(u => {
                return u[1]
            }))
            if (ar.length === lln.segments.length) {
                if (type === 'move') {
                    const loc = [];
                    lln.segments.map((s, ix) => {
                        loc.push(new paper.Segment([s.point.x + event.movementX, s.point.y + event.movementY]))
                    })

                    lln.removeSegments()
                    lln.addSegments(loc)
                    movedRef.current = true;
                }
            }
            selectionRef.current = ar;
//console.log(tl.tLine.segments)
            /*  */

        }
    };

    const handlePointerUp = () => {
        dragRef.current = null;
    };
    const [selection, setSelection] = useState(null);
    const dragRef = useRef(null);
    const canvasRef = useRef(null);
    const movedRef = useRef(false);
    const selectionRef = useRef(null);
    const getSvgPathFromStroke = (stroke) => {
        if (!stroke.length) {
            return '';
        }

        const d = stroke.reduce(
            (acc, [x0, y0], i, arr) => {
                const [x1, y1] = arr[(i + 1) % arr.length];
                acc.push(x0, y0, (x0 + x1) / 2, (y0 + y1) / 2);
                return acc;
            },
            ['M', ...stroke[0], 'Q']
        );

        d.push('Z');
        return d.join(' ');
    }

    function* chunkGenerator(arr, size) {
        for (let i = 0; i < arr.length; i += size) {
            yield arr.slice(i, i + size);
        }
    }

    const types = ['aqua', 'flo', 'pen'];
    const [dia, setDia] = useState(null);
    const [rect, setRect] = useState(null);
    const [rect1, setRect1] = useState(null);
    const [mat, setMat] = useState([1, 0, 0]);
    const [stories, setStories] = useState(null);
    const [lines, setLines] = useState([]);
    const [gs, setGs] = useState([]);
    const [stroke, setStroke] = useState(null);
    const [lln, setLln] = useState(null);
    const tranP = useRef(null);
    const box = useRef(0);
    const [story, setStory] = useState(null);
    const [loaded, setLoaded] = useState(null);
    const [color, setColor] = useState('rgba(0,0,0,0.5)');
    const [colors, setColors] = useState([]);
    let zoom = false;

    const choose = (s = false) => {

        if (!s) {
            let cls = colors
            !colors.find(s => s == color) && cls.unshift(color);
            cls = cls.slice(0, 4)
            setColors(cls)
        }    // console.log(stroke)
        stroke.ln.strokeColor = new paper.Color(s);
        setColor(s)
    }
    const SetCool = (n) => {
        setColor(n)

    }
//const story=34;
    const navigate = useNavigate();
    let coef;
    let size;
    let hhR;
    let hi, wi, hh, ww, sujet;
    const updd = (n) => {
        const res = {};
        const v = window.document.getElementById(n).value;
        res[n] = v;
        upd(res);
    }
    const updVid = (file) => {
        fetch('https://morning-dawn-3bf1.facereplays.workers.dev/' + file, {
            method: "DELETE"
        }).then((response) => response.json()).then(a => {
            //   console.log(a)
            a.del && a.del == 1 && createConnection().update('sujet', dia.id, {video: null}).then(o => window.location.reload());
        });
        //;
    }
    const upd = (data) => {
        if (data.delete) {

            const del = data.delete.split('/').pop()
            fetch('https://morning-dawn-3bf1.facereplays.workers.dev/' + del, {
                method: "DELETE"
            }).then((response) => response.json()).then(a => {
                // console.log(a)
                a.del && a.del == 1 && createConnection().update('sujet', dia.id, data).then(o => window.location.reload());
            });

        } else {

            createConnection().update('sujet', dia.id, data).then(o => window.location.reload());
        }       //;
    }
    const [searchParams, setSearchParams] = useSearchParams();
    const peg = searchParams.get('p');
    const load = searchParams.get("load");
    let tLine;
    const su = searchParams.get('su');
    let cir;
    let cir1;

    const loadLoad=async(load)=>{
        const response = await fetch(`/forman/${load}`);
        const data = await response.json();
        if(data.lines) {
            setLoaded(data)

        }else{
          paper.setup([100,100]);
           pubN(JSON.parse(data))

        }


    }
    useEffect(() => {
        //su && paper.setup([100, 100]);
if(load){
   loadLoad(load);

}
        const sca = 1;


        /**/

        const id = searchParams.get('id');
        const pp = peg ? '&page=' + peg + ',1' : '&size=1';
        const filter = id ? '?join=objet&filter=id,eq,' + id : su ? '?filter=id,gt,1776&join=objet&order=id,desc&page=' + su + ',1' : '?order=id,desc&join=objet' + pp;
        // console.log(filter);

        if (peg) {
            createConnection().get('objet', 'join=strokes&order=id,desc' + pp).then(f => {
                const obj = f.records[0];
                const strks = obj.strokes.sort((a, b) => a.id - b.id);
                createConnection().getnu('objet/' + obj.id + '?join=strokes').then(fu => {
                    if (fu.strokes.length == 0) {


                        strks.map((s, i) => {
                            s.colorCSS = new paper.Color(s.color).toCSS(true);

                            s.color = s.color.match(/\#/) ? new paper.Color(s.color).toCSS(false) : s.color;

                            const r = []
                            s.line = s.dots ? JSON.parse(s.dots.replace(/{/g, '[').replace(/}/g, ']')) : s.line != '[]' ? JSON.parse(s.line) : [];
//delete s.id;
                            if (s.start < 1000) s.start = i;
                            s.line.map(h => {
                                h.x ? r.push({po: JSON.stringify([h.x, h.y, h.pressure])}) : r.push({po: JSON.stringify(h.map(tf => parseFloat(tf)))})
                            })
                            s.line = '[]';
                            delete s.dots;
                            createConnection().getnue({parent: obj.id, target: 'strokes', data: [s]}, 'POST').then(
                                res => {
                                    const id = res.con[0];
                                    r.map(y => {
                                        y.strokes = id
                                    })
                                    createConnection().getnue({target: 'point', data: r}, 'POST').then(ff => {


                                        if (i == strks.length - 1) {
                                            // console.log(id)
                                            // setTimeout(  window.location.href='/form?p='+(Number(peg)+1),200000)

                                        }
                                    })

                                }
                            )


                        })
                    }

                })


            })

            return;
        }


        createConnection().getnu('sujet' + filter).then(f => {

            const a = f.records[0];
            console.log(a);
            wi = window.innerWidth * .9;
            hi = window.innerHeight * .9;
            //      console.log(a,wi, hi);
            size = a.size.split(',').map(c => Number(c)).concat([0, 0]);
//size[2]=0;size[3]=0;
            sujet = a;
            sujet.sizen = size;
            setDia(sujet);
            let w = Number(size[0]);
            size.length > 2 ? w -= Math.min(0, Number(size[2])) : null;
            const h = size.length > 3 ? Number(size[1]) : Number(size[1]);
            const totL = a.totaltime;
            if (h > w) {
                if (hi / wi >= h / w) {

                    coef = (wi / w);
                    hhR = (hi / wi * w - h) / 2;
                } else {

                    coef = hi / h;
                }
            } else {

                if (hi / wi >= h / w) {

                    coef = (wi / w);
                    hhR = (hi / wi * w - h) / 2;
                } else {

                    coef = hi / h;
                }


            }
            coef = coef * sca;
            coef = 1;
            hh = h * coef;
            ww = w * coef;
            const genMat = new paper.Matrix(coef, 0, 0, coef, size[2], size[3]);

            sujet.ww = ww;
            sujet.hh = hh;
            if (!su) a.objet.map(o => {
                const iid = o.id;
                const tran = o.transforms ? JSON.parse(o.transforms) : []
                const tra = tran.length > 0 ? tran[tran.length - 1] : [0, 0, 1, 0, 0]
                const strks = [];
                const dts = [];

                createConnection().getnu('strokes?filter=objet,eq,' + iid, null, 'GET').then(dd => {
///block re recording
                    if (dd.records.length > 800000) {

                        createConnection().get('strokes', 'order=start,asc&filter=objet,eq,' + iid).then((a, i) => {


                            //
                            //   console.log(a);

                            const lns = [];
//createConnection().getnu('strokes?exclude=po&filter=objet,eq,'+iid,null,'GET').then(dd=>{console.log(dd.records.length);})
                            const recs = a.records.map((u, i) => {


                                /*
                                g(r);
                                     })
                                 */
                                u.line = u.dots ? JSON.parse(u.dots.replace(/{/g, '[').replace(/}/g, ']')) : u.line != '[]' ? JSON.parse(u.line) : [];
//console.log(u.id,u.line);


                                const r = [];
                                u.line.map(h => {//console.log(h);
                                    Number(h.pressure) >= 0 ? r.push({po: JSON.stringify([h.x, h.y, h.pressure])}) : r.push({po: JSON.stringify(h.map(tf => parseFloat(tf)))})
                                });


                                let p;
                                u.lineD = u.line.filter(h => {
                                    let ret = false;
                                    if (!p) ret = true; else {
                                        if (h.x) {
                                            if (p.x != h.x && p.y != h.y) ret = true;


                                        } else {
                                            if (p[0] != h[0] && p[1] != h[1]) ret = true;


                                        }
                                    }
                                    p = h;


                                    return ret ? h : null;

                                }).map(h => {
//console.log(h)
                                    return !h.x ? {
                                        x: h[0],
                                        y: h[1],
                                        pressure: h[2] * sca
                                    } : {
                                        x: h.x,
                                        y: h.y,
                                        pressure: h.pressure * sca
                                    };

                                });

//u.opts=new Opts(u.size ? u.size:1,u.type);

                                u.opts = {
                                    size: u.width ? 0.02 * u.width : 0.2, thinning: 1,
                                    simulatePressure: false
                                }
                                //  console.log(u)
                                const ln = new paper.Path(u.lineD.map(a => [a.x, a.y]));

                                u.svg = ln.exportSVG({asString: true}).match(/\bd="([^"]+)"/)[1]

                                if (!u.delta || u.delta > 0) {
                                    //  console.log(u);
                                    const ln = new paper.Path(u.lineD.map(a => [a.x, a.y]));


                                    ln.data = {dots: u.lineD, id: u.id};
                                    ln.onClick = (e => {
                                        const bo = e.target.bounds;
                                        svgSel(u, e, ln)

                                        paper.project.activeLayer.children[0].children.map(ch => ch.fullySelected = false);
                                        e.target.fullySelected = true;
//const mat=new paper.Matrix(3,0,0,3,-bo.x*3+10,-bo.y*3+10);
                                        // paper.project.activeLayer.children[0].opacity=0.4;
                                        // paper.project.activeLayer.children[0].transform(mat)
                                    });
                                    ln.style = {
                                        fillColor: null,
                                        strokeWidth: u.width ? u.width : 8,
                                        strokeJoin: 'round', strokeCap: 'round',
                                        strokeColor: u.color,

                                    };
                                    // console.log(paper.project.activeLayer.children[0]);
                                    paper.project.activeLayer.children[0].addChild(ln);
                                    u.delta = ln.length;
                                    u.ln = ln;
                                    //paper.project.view.update();
                                }

                                u.d = getSvgPathFromStroke(getStroke(u.lineD, u.opts));

                                const col = u.color.match(/([\d|,|\.]+)/) ? u.color.match(/([\d|,|\.]+)/)[0].split(',') : [0, 0, 0, 1];


                                const paint2 = u.color;
                                console.log(u.color)

                                u.paint = paint2;
                                lns.push(u);
                                const dat = {
                                    start: i,
                                    line: '[]',
                                    objet: iid,
                                    color: u.color,
                                    delta: Math.floor(u.delta),
                                    type: u.type,

                                    totalpoints: r.length
                                }
                                strks.push(dat);
                                dts.push(r);
                                return u;


                            });


                            createConnection().getnu('strokes?filter=objet,eq,' + iid, null, 'GET').then(dd => {
                                createConnection().getnue({parent: iid, target: 'strokes', data: strks}, 'POST').then(
                                    rr => {
                                        let all = []
                                        rr.con.map(
                                            (x, i) => {
                                                //  console.log(dts[i])

                                                all = all.concat(dts[i].map(b => {
                                                    b.strokes = x;
                                                    return b;
                                                }))
                                                // c

                                            }
                                        )


// Использование:
                                        for (const chunk of chunkGenerator(all, 5000)) {
                                            // Отправляем чанк в базу данных или обрабатываем
                                            createConnection().getnue({
                                                target: 'point',
                                                data: chunk
                                            }, 'POST').then(ff => {
                                                if (chunk.length < 5000 && ff.con) window.location.href = '/form?p=' + (Number(peg) + 1)
                                            })
                                        }


                                    }
                                )

                                /*
                                    strks.map((s, ty) => {
                                        const pos =dts[ty];

                                     if(pos.length>1){
                                         createConnection().getnu('strokes',s, 'POST').then(dd => {
                                             const ppos=pos.map(y => {y.strokes=dd; return y;})

                                           createConnection().getnue({target:'point',data:ppos}, 'POST').then(ddd => {})


                                         })

                                     }

                                })

                                    /*
                                    if (dd.records.length == 0) {
                                        strks.map((s, ty) => {
                                            const r = s.r;
                                            s.delta = Math.floor(s.delta)
                                            delete s.r;

                                            createConnection().getnu('strokes?d=' + ty, s, 'POST').then(dd => {
                                                r.map(y => y.strokes = dd)
                                                createConnection().getnu('point', r, 'POST')

                                            })

                                        })


                                    }
                               */
                            })

                            setLines(lns);
                            paper.project.view.update();
                        })

                    } else {
                        createConnection().getnu('strokes?join=point&order=start,asc&filter=objet,eq,' + iid,).then((a, i) => {


                            //


                            const lns = [];
//createConnection().getnu('strokes?exclude=po&filter=objet,eq,'+iid,null,'GET').then(dd=>{console.log(dd.records.length);})
                            const recs = a.records.map((u, i) => {

                                const cor = u.corecn ? u.corecn.split(',').map(x => Number(x)) : [0, 0, 1, 1];
                                u.point = u.point.filter(a => !a.pu && a).sort((a, b) => a.id - b.id)
                                u.color=u.color.replace(/ /g,'');
                                u.line = u.point && u.point.length > 0 ? u.point.sort((a, b) => a.id - b.id).map(g => {
                                    g = JSON.parse(g.po);
                                    return {x: g[0] * tra[2], y: g[1] * tra[2], pressure: g[2]}
                                }) : JSON.parse(u.line).map(g => {

                                    return {x: Number(g[0]), y: Number(g[1]), pressure: Number(g[2])}
                                }).filter(x => x.pressure > -1)


                                let p;
                                u.lineD = u.line.map(h => {
//console.log(h)
                                    /*  return !h.x ? {
                                          x: (h[0] + size[2]) * coef,
                                          y: (h[1] + size[3]) * coef,
                                          pressure: h[2] * sca
                                      } : {
                                          x: h.x * coef + size[2] * coef,
                                          y: h.y * coef + size[3] * coef,
                                          pressure: h.pressure * sca
                                      };
                                  */
                                    return !h.x ? {
                                        x: h[0],
                                        y: h[1],
                                        pressure: h[2] * sca
                                    } : {
                                        x: h.x,
                                        y: h.y,
                                        pressure: h.pressure * sca
                                    };
                                });
//console.log(u.lineD);
//u.opts=new Opts(u.size ? u.size:1,u.type);

                                u.opts = {
                                    size: u.width ? 0.02 * u.width : 0.2, thinning: 1,
                                    simulatePressure: false
                                }
                                if (!u.delta || u.delta > 0) {

                                    //u.lineD= u.lineD.filter((j,i)=> i<u.lineD.length-966/2)

                                    const ln = new paper.Path(u.lineD.map(a => [a.x, a.y]));

                                   // ln.smooth({type: 'continuous'})
                                    ln.segments.map((seg, i) => {
                                        const nor = (ln.getNormalAt(ln.getOffsetOf(seg.point)))
                                        u.lineD[i].nor = nor;
                                    })
                                    let str = '';

                                    if (u.type == 'pen') {
                                        let resu = getCLByWidth(u.lineD, 1, 6, 1)
                                        resu.filter(o => o.length > 1).map(
                                            o => {
                                                const lun = new paper.Path(o.map(a => [a.x, a.y]));
                                                lun.smooth({type: 'continuous'})
                                                str += lun.exportSVG({asString: true}).match(/\bd="([^"]+)"/)[1]

                                            }
                                        )
                                        resu = getCLByWidth(u.lineD, 6,11, 2)
                                        resu.filter(o => o.length > 1).map(
                                            o => {
                                                const lun = new paper.Path(o.map(a => [a.x, a.y]));
                                                lun.smooth({type: 'continuous'})
                                                str += lun.exportSVG({asString: true}).match(/\bd="([^"]+)"/)[1]

                                            }
                                        )

                                    }
                                    /***

                                     {
                                     size: 52,
                                     smoothing: 0.01,
                                     thinning: 0,
                                     streamline: 0.34,
                                     easing: (t) => t,
                                     start: {
                                     taper: 0,
                                     cap: true,
                                     },
                                     end: {
                                     taper: 0,
                                     cap: true,
                                     },
                                     }
                                     }

                                     */



/***
 {
 size: 29,
 smoothing: 0.51,
 thinning: -0.48,
 streamline: 0.34,
 easing: (t) => t,
 start: {
 taper: 89,
 cap: true,
 },
 end: {
 taper: 85,
 cap: true,
 },
 }

 */

                                    u.opts = u.type == 'Pen' ? {
                                        size: u.width ? u.width*0.8 : 1,

                                        streamline: 0.3,
                                        smoothing: 0.51,
                                        thinning: -0.48,
                                        easing: (t) => t,
                                        start: {
                                            taper: 85,
                                            cap: true,
                                        },
                                        end: {
                                            taper: 85,
                                            cap: true,
                                        },
                                        simulatePressure: true
                                    } : u.opts = u.type == 'Highlighter' ? {

                                        smoothing: 0,
                                        thinning: 0,
                                        streamline: 0.3,
                                        easing: (t) => t,
                                        start: {
                                            taper: 0,
                                            cap: false,
                                        },
                                        end: {
                                            taper: 0,
                                            cap: false,
                                        },

                                        size: u.width ? u.width : 0.2,

                                        simulatePressure: false
                                    } : {
                                        size: u.width ? 0.02 * u.width : 0.2,
                                        thinning: 1,
                                        simulatePressure: false
                                    }

                                    //{ type: 'catmull-rom', factor: 0.8 });
                                    if( u.type == 'Highlighter'){

                                        let resu = getHighLigtt(u.lineD,  u.width )
                                        const ln1 = new paper.Path(u.lineD.map(a => [a.x, a.y]));
                                        //   u.svg = resu.exportSVG({asString: true}).match(/\bd="([^"]+)"/)[1]

                                        u.svg = ln1.exportSVG({asString: true}).match(/\bd="([^"]+)"/)[1]
                                       //  u.svg = getSvgPathFromStroke(getStroke(u.lineD, u.opts));


                                    }else if(u.type == 'Pen' ){
                                        ln.smooth({type: 'continuous'})
                                         u.svg = ln.exportSVG({asString: true}).match(/\bd="([^"]+)"/)[1]


                                      u.svg+= getSvgPathFromStroke(getStroke(u.lineD, u.opts));


                                    }else{
                                    u.svg = str + ' ' + ln.exportSVG({asString: true}).match(/\bd="([^"]+)"/)[1]
                                    }
                                    // str.length>10   &&   console.log(u.svg)
                                    ln.data = {u: u, dots: u.lineD, id: u.id, sizen: sujet.sizen, coef: coef};
                                    ln.onClick = (e => {
                                        const bo = e.target.bounds;
                                        const p = new paper.Point(e.point.x / coef - sujet.sizen[2] / coef, e.point.y / coef - sujet.sizen[3] / coef)

                                        let m = [1000000, 0, ln, u]

                                        u.point.map((v, ib) => {
                                            const len = ln.segments[ib].point.subtract(p).length
                                            m = len <= m[0] ? [Math.min(m[0], len), ib, ln, u, ln.segments[ib], v] : m;
                                        })
                                        console.log(m[5], m[4].point)
                                        /*

                                        ln.segments.map((v,ib)=> {
                                                const len=v.point.subtract(p).length


                                        }
                                        )
                                        */
                                        cir1.position = m[4].point;

                                        cir.position = new paper.Point(ln.segments[m[1]].point.x, ln.segments[m[1]].point.y)
                                        tranP.current = m;

                                        svgSel(u, new paper.Point(e.point), ln)


                                        paper.project.activeLayer.children[0].children.map(ch => ch.fullySelected = false);
                                        e.target.fullySelected = true;
//const mat=new paper.Matrix(3,0,0,3,-bo.x*3+10,-bo.y*3+10);
                                        // paper.project.activeLayer.children[0].opacity=0.4;
                                        // paper.project.activeLayer.children[0].transform(mat)
                                    });
                                    ln.style = {
                                        fillColor: null,
                                        strokeWidth: u.width ? u.width / 3 : 4,
                                        strokeJoin: 'round', strokeCap: 'round',
                                        strokeColor: u.color,

                                    };
                                    // console.log(paper.project.activeLayer.children[0]);
                                    paper.project.activeLayer.children[0].addChild(ln);
                                    u.delta = ln.length;
                                    u.ln = ln;
                                    //paper.project.view.update();
                                }

                                u.d = getSvgPathFromStroke(getStroke(u.lineD, u.opts));

                                const col = u.color.match(/([\d|,|\.]+)/) ? u.color.match(/([\d|,|\.]+)/)[0].split(',') : [0, 0, 0, 1];


                                const paint2 = u.color;


                                u.paint = paint2;
                                lns.push(u);

                                return u;


                            });
                            /*


                             */

                            createConnection().getnu('strokes?filter=objet,eq,' + iid, null, 'GET').then(dd => {

                                if (dd.records.length == 0) {
                                    strks.map((s, ty) => {
                                        const r = s.r;
                                        s.delta = Math.floor(s.delta)
                                        delete s.r;

                                        createConnection().getnu('strokes', s, 'POST').then(dd => {
                                            r.map(y => y.strokes = dd)
                                            createConnection().getnu('point', r, 'POST')

                                        })

                                    })


                                }
                            })
                            const lld = lns.sort((a, b) => Number(a.color.replace(/[r|g|b|a|,|\.|\(|\)]/g,'')) - Number(b.color.replace(/[r|g|b|a|,|\.|\(|\)]/g,'')))
                            const art = []
                            let g = []
                            let col = '';
                            let y = 0;
                            lld.map((u, i) => {

                                if (u.color != col) {
                                    g = [u]
                                    col = u.color;
                                    art[y] = g
                                    y++;


                                } else {
                                    g.push(u)
                                }


                            })


                            setGs(art)
                            setLines(lns);


                            //
                            const d = new paper.Path.Rectangle(new paper.Rectangle(0, 0, 10, 10))
                            d.fillColor = new paper.Color(0, 0, 0)
                            paper.project.activeLayer.children[0].addChild(d);

                            paper.project.activeLayer.children[0].transform(genMat);
                            paper.project.activeLayer.children[1].transform(genMat);
                            // paper.project.view.update();
                            // paper.project.activeLayer.children[1].matrix=genMat;
                        })
                    }
                })
            })
            const getDia = () => dia;
            setTimeout(() => {
                const canvas1 = document.getElementById('sa');
                // Create an empty project and a view for the canvas:

                paper.setup(canvas1);
                canvas1.width = ww;
                canvas1.height = hh;
                console.log(paper.project.view.size)
                const gr = new paper.Group({});
                gr.applyMatrix = false;
                paper.project.activeLayer.addChild(gr);
                const gr1 = new paper.Group({});
                //gr1.applyMatrix = false;
                paper.project.activeLayer.addChild(gr1);
                tLine = new paper.Path.Line();
                tLine.strokeColor = new paper.Color('red');
                tLine.strokeWidth = 10;
                gr1.data = {tLine: tLine}
                gr1.addChild(tLine)

                cir = new paper.Path.Circle(new paper.Point(0, 0), 30);
                cir.fillColor = 'rgba(100,0,0,.3)';
                cir.applyMatrix = true;
                cir1 = new paper.Path.Circle(new paper.Point(0, 0), 10);
                cir1.fillColor = 'rgba(200,0,0,.5)';
                cir1.applyMatrix = true;
                paper.project.activeLayer.children[0].addChild(cir)
                paper.project.activeLayer.children[0].addChild(cir1)
                cir.onMouseUp = function (event) {

                    const mat = new paper.Matrix(1, 0, 0, 1, -event.point.x, -event.point.y);
                    // paper.project.activeLayer.children[0].opacity=0.4;
                    const lin = tranP.current[2];
                    const pt = tranP.current[1];

                    const jj = lin.segments.map((v, ib) => {
                        if (ib == pt) {
                            const ppo = JSON.parse(tranP.current[3].point[ib].po)
                            ppo[0] = (v.point.x);
                            ppo[1] = (v.point.y);


                            const data = {po: JSON.stringify(ppo)}
                            createConnection().update('point', tranP.current[3].point[ib].id, data).then();
//
                            // o => window.location.reload() v.point=new paper.Point(event.point)
                        }
                    })
                    //console.log(jj)

                    cir.transform(mat)
                }
                cir.onMouseDrag = function (event) {
                    const lin = tranP.current[2];
                    const mov = new paper.Point(event.delta.x / lin.data.coef, event.delta.y / lin.data.coef);
                    // cir.position += event.delta;
                    // const mat=new paper.Matrix(1,0,0,1,event.delta.x,event.delta.y);
                    // paper.project.activeLayer.children[0].opacity=0.4;
                    cir.translate(mov)
                    // cir.transform(mat)

                    const pt = tranP.current[1];
                    const jj = lin.segments.map((v, ib) => {
                        if (ib == pt) {
                            const d = new paper.Point(v.point.x, v.point.y)
                            v.point = d.add(mov)
                        }
                    })
                    //console.log(jj)
                }

            }, 100)
            createConnection().getnu('story', null, 'GET').then(f => {
                //  console.log(f)

                f.records.map(sto => {

                    sto.id == sujet.story && setStory(sto);

                })
                setStories(f.records);


            })
        }).catch((er) => {
            console.log(er)
        })
        return () => {
            if (mydiv.current) {
                mydiv.current.removeEventListener("pointermove", pmove);
                mydiv.current.removeEventListener("pointerdown", pDown);
                mydiv.current.removeEventListener("pointerup", pstop)
                mydiv.current.removeEventListener("pointerleave", pstop)

            }


        }
    }, []);
    const mydiv = useRef(null);
    const pmove = (po) => {

        //console.log(po)
    }
    const pDown = (ev) => {
        console.log('ddd', ev)
        startP.x = ev.offsetX;
        startP.y = ev.offsetY;
        mydiv.current.addEventListener("pointermove", pmove)
        mydiv.current.addEventListener("pointerup", pstop)
        mydiv.current.addEventListener("pointerleave", pstop)
    }
    const pstop = (po) => {
        mydiv.current.removeEventListener("pointermove", pmove);
        mydiv.current.removeEventListener("pointerdown", pDown);
        mydiv.current.removeEventListener("pointerup", pstop)
        mydiv.current.removeEventListener("pointerleave", pstop)
        zoom = zoom == 1 ? 0 : 1;
        console.log('stop')
        mydiv.current.style.cursor = 'pointer';
        if (po.type != 'pointerleave') {
            const endP = new paper.Point(po.offsetX, po.offsetX);
            const dis = (po.offsetX - startP.x) / dia.ww;

            paper.project.activeLayer.children[0].matrix = new paper.Matrix(1 / dis, 0, 0, 1 / dis, -startP.x / dis, -startP.y / dis);
        }
    }
    const startP = new paper.Point(0, 0);
    const se = (e) => {
        zoom = zoom == 1 ? 0 : 1;
        if (zoom == 1) {


            mydiv.current.style.cursor = 'zoom-in';
            mydiv.current.addEventListener("pointerdown", pDown)
        } else {

            mydiv.current.style.cursor = 'pointer';
        }  /*
    mydiv.current.addEventListener("wheel", (event) => {
      let scale=   mat[0];
      console.log(event.deltaY);
      if(event.deltaY<0 ) {
scale=scale*1.4;
        const x=-event.offsetX*scale;
        setMat([scale,-event.offsetX*(scale-1),-event.offsetY*(scale-1)]);
      }else{

       // setMat([1,0,0]);
      }
      console.log(mat)

    });

     */
    }
    const sele = (e) => {
        localStorage.setItem('defStory', e.target.value);
        upd({story: e.target.value});


    }
    const defStory = localStorage.getItem('defStory') ? localStorage.getItem('defStory') : 70;
    const  createRandomString = (length)=>{
        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let result = "";
        for (let i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    }

    const pubN = (data) => {
        const colors = [[232, 64, 38], [247, 206, 0], [100, 187, 92], [70, 178, 227], [86, 74, 246], [172, 73, 244], [25, 25, 25], [255, 255, 255], [254, 215, 216], [255, 228, 207], [255, 243, 209], [255, 235, 208], [235, 247, 209], [221, 245, 221], [208, 243, 245], [209, 239, 250], [209, 231, 255], [220, 224, 251], [233, 216, 250], [250, 208, 230], [242, 242, 242], [252, 196, 197], [255, 217, 186], [254, 237, 185], [255, 226, 186], [223, 243, 184], [205, 241, 205], [186, 237, 240], [184, 231, 249], [185, 219, 255], [203, 208, 250], [223, 196, 247], [246, 185, 218], [230, 230, 230], [252, 158, 159], [255, 192, 139], [255, 225, 139], [255, 208, 140], [202, 236, 139], [171, 231, 171], [140, 225, 230], [140, 217, 247], [139, 195, 254], [167, 178, 244], [201, 158, 240], [242, 139, 194], [217, 217, 217], [252, 119, 122], [255, 167, 93], [254, 214, 92], [255, 189, 92], [181, 227, 92], [137, 222, 137], [92, 213, 221], [92, 201, 244], [92, 173, 255], [132, 147, 242], [180, 119, 236], [237, 92, 169], [204, 204, 204], [250, 80, 83], [255, 142, 46], [255, 202, 46], [255, 169, 46], [161, 221, 47], [104, 213, 104], [45, 202, 209], [46, 185, 240], [46, 148, 255], [97, 116, 237], [159, 80, 231], [232, 46, 145], [179, 179, 179], [251, 42, 45], [255, 117, 0], [255, 190, 0], [255, 151, 0], [139, 214, 0], [70, 204, 71], [0, 191, 201], [0, 170, 239], [0, 125, 254], [62, 86, 234], [138, 43, 225], [228, 0, 121], [128, 128, 128], [228, 40, 41], [232, 107, 0], [232, 175, 0], [232, 139, 0], [128, 195, 1], [64, 186, 65], [0, 174, 183], [0, 156, 217], [0, 113, 231], [59, 79, 214], [127, 40, 205], [208, 0, 110], [77, 77, 77], [205, 35, 36], [209, 96, 0], [210, 157, 1], [209, 125, 0], [116, 176, 0], [59, 167, 58], [0, 157, 164], [0, 139, 194], [0, 103, 208], [52, 71, 192], [112, 36, 186], [186, 0, 99], [51, 51, 51], [181, 31, 33], [186, 86, 0], [186, 139, 1], [187, 111, 1], [102, 156, 0], [52, 149, 52], [0, 139, 146], [0, 124, 175], [1, 91, 187], [46, 63, 171], [102, 32, 165], [167, 0, 88], [0, 0, 0], [160, 27, 30], [163, 75, 1], [162, 122, 0], [163, 97, 0], [90, 137, 0], [46, 130, 45], [0, 121, 129], [0, 109, 152], [0, 81, 163], [41, 56, 149], [88, 27, 144], [146, 0, 77]];
console.log(data)
        const maxY = Math.floor(data.maxY);

        let l = 0;
        let w = 0;
        let mar = 100000000;
        let mary = 100000000;
        data.paintStateList.forEach((u, ii) => {

            const co = [colors[u.colorIndex][0], colors[u.colorIndex][1], colors[u.colorIndex][2]].map(i => i / 255);
            const color = 'rgba('.concat(colors[u.colorIndex].join(','), ',0.8)');
            const col = new paper.Color(co[0], co[1], co[2]).saturation;


            let ww = u.pointsList[1].width - u.pointsList[0].width;
            const lineSt = u.pointsList.map((a, i) => {

                return {po: JSON.stringify([a.x, a.y, a.width * 0.6])};
            })
            u.lineSt = lineSt;
            u.color = color;
            const line = u.pointsList.map((a, i) => {

                if (i > 0) {
                    const aa = a.width - u.pointsList[i - 1].width;
                    if (Math.floor(ww * 100) === Math.floor(aa * 100)) {

                        //console.log('m ' + Math.floor(aa * 100), Math.floor(ww * 100));
                    } else {
                        // console.log(Math.floor(aa * 100), Math.floor(ww * 100));

                    }
                    ww = aa;
                }

                return {x: a.x, y: a.y, pressure: a.width * 0.6};
            });


            const minX = u.pointsList.sort((c, b) => c.x - b.x)[0].x;
            const minY = u.pointsList.sort((c, b) => c.y - b.y)[0].y;
            w = Math.round(Math.max(u.pointsList.sort((c, b) => b.x - c.x)[0].x, w));
            mar = Math.round(Math.min(minX, mar));
            mary = Math.round(Math.min(minY, mary));


        });
        let tot = 0;

        const arr = data.paintStateList.map((f, i) => {

            const pa = new paper.Path(f.pointsList.map((a) => new paper.Segment(new paper.Point(a.x, a.y))));
            tot += pa.length + 40;
            /***
             *
             *
             *
             *  ALTER TABLE tbl_name DROP COLUMN col_name
             *  color
             * :
             * "rgba(25,25,25,0.8)"
             * dots
             * :
             * "{{285.459,1077.090,1.324},{285.459,1077.090,1.324},{285.264,1077.481,1.400},{284.857,1078.311,1.476},{284.093,1081.457,1.577},{283.476,1084.608,1.678},{282.885,1087.831,1.780},{282.305,1091.103,1.881},{281.76,1094.337,1.924},{281.282,1097.52,1.967},{280.854,1100.760,2.009},{280.476,1104.059,2.052},{280.160,1107.271,2.095},{279.896,1110.471,2.138},{279.675,1113.721,2.180},{279.498,1117.023,2.223},{279.366,1120.293,2.266},{279.259,1123.465,2.297},{279.164,1126.693,2.328},{279.083,1129.979,2.360},{279.013,1133.322,2.391},{278.959,1136.544,2.422},{278.918,1139.736,2.453},{278.887,1142.977,2.485},{278.867,1146.266,2.516},{278.858,1149.604,2.547},{278.859,1152.918,2.564},{278.871,1156.195,2.580},{278.892,1159.468,2.597},{278.924,1162.735,2.614},{278.967,1165.997,2.630},{279.019,1169.254,2.647},{279.082,1172.506,2.663},{279.154,1175.753,2.680},{279.237,1178.995,2.697},{279.331,1182.231,2.713},{279.436,1185.513,2.730},{279.557,1188.894,2.745},{279.690,1192.2,2.761},{279.834,1195.430,2.776},{279.990,1198.586,2.791},{280.166,1201.808,2.806},{280.369,1205.181,2.822},{280.586,1208.459,2.837},{280.818,1211.642,2.852},{281.066,1214.745,2.868},{281.355,1218.188,2.902},{281.633,1221.484,2.937},{281.902,1224.633,2.971},{282.175,1227.803,3.006},{282.473,1231.213,3.040},{282.757,1234.410,3.074},{283.035,1237.494,3.109},{283.354,1240.933,3.181},{283.673,1244.269,3.253},{283.992,1247.503,3.324},{284.311,1250.635,3.396},{284.63,1253.663,3.468},{285.020,1257.116,3.566},{285.412,1260.174,3.665},{285.924,1263.563,3.763},{286.531,1266.699,3.861},{286.706,1267.443,3.870},{286.880,1268.118,3.879},{287.055,1268.726,3.889},{287.314,1269.503,3.898},{287.612,1270.213,3.907},{287.910,1270.726,3.917},{288.492,1271.267,3.740},{289.059,1271.134,3.564},{289.976,1268.066,2.936},{290.069,1267.304,2.793},{290.151,1266.469,2.651},{290.220,1265.667,2.508},{290.279,1264.930,2.366},{290.327,1264.258,2.223},{290.373,1263.486,2.081},{290.403,1262.739,1.938},{290.411,1261.977,1.796},{290.411,1261.044,1.209},{290.411,1260.857,0.623}}"
             * line
             * :
             * " "
             * objet
             * :
             * 544
             * start
             * :
             * 0
             * type
             * :
             * "pen"
             */
            // @ts-ignore
            return {
                start: i,
                line: '[]',
                dots: f.lineSt,
                objet: 'sid',
                color: f.color,
                delta: Math.ceil(pa.length),
                type: types[f.paintType - 1]
            }
        });


        const may = Math.round(maxY * 1.1);
        if (arr.length > 3) {
            const ar1 = arr.map(m => {
                return {po: m.dots}
            });
            const ar2 = arr.map(m => {
                m.totalpoints = m.dots.length;
                delete m.dots;
                return m
            });

            if (su) {
                let r = [];

                createConnection().getnue({parent: obj.id, target: 'strokes', data: ar2}, 'POST').then(
                    dd => {
                        console.log(dd.con[0]);

                        dd.con.map((ddd, ig) => {
                            if (ar1[ig]) {

                                const f = ar1[ig]

                                if (f.po instanceof Array) {

                                    f.po.map(y => y.strokes = ddd)
                                    r = r.concat(f.po)
                                }
                            }
                        })


                        createConnection().getnue({target: 'point', data: r}, 'POST').then(ff => {


                            window.location.href = '/form?su=' + (Number(su) + 1)
                        })

                    })

            } else {

                createConnection().insert('sujet', {
                    user: 11,
                    name: createRandomString(8),
                    story: defStory,
                    totaltime: Math.ceil(tot),
                    size: w.toString().concat(',', may.toString(), ',', mar.toString(), ',', mary.toString())
                }, 2).then(c => {

                    createConnection().insert('objet', {
                        sujet: c,
                        start: 0,
                        delta: 0,
                        deltaR: 0
                    }, 2).then(cc => {
                        let r = [];
                        console.log('delete from strokes where objet=' + cc + ';delete from objet  where id=' + cc + ';delete from sujet  where id=' + c + ';')


                        createConnection().getnue({parent: cc, target: 'strokes', data: ar2}, 'POST').then(
                            dd => {
                                //  console.log(dd.con[0]);

                                dd.con.map((ddd, ig) => {
                                    if (ar1[ig]) {

                                        const f = ar1[ig]

                                        if (f.po instanceof Array) {

                                            f.po.map(y => y.strokes = ddd)
                                            r = r.concat(f.po)
                                        }
                                    }
                                })


                                createConnection().getnue({target: 'point', data: r}, 'POST').then(ff => {

window.location.href = '/form';
                                })

                            })


                    });
                })
            }

            // console.log(arr,'sujet', 'siid', {totaltime:Math.ceil(tot),size:w.toString().concat(',', may.toString(),',',mar.toString(),',',mary.toString())});
            return arr;


        }

    }
    const pub = async (obj) => {
        const clipboardContents = await navigator.clipboard.read();

        for (const item of clipboardContents) {
            for (const mimeType of item.types) {
                let blobText;
                if (mimeType === "text/plain") {
                    const blob = await item.getType("text/plain");
                    blobText = await blob.text();

                } else if (mimeType === "text/html") {
                    const blob = await item.getType("text/html");
                    blobText = await blob.text();


                } else {
                    throw new Error(`${mimeType} not supported.`);
                }

               pubN(JSON.parse(blobText)) ;
            }

        }
    }
    const upStroke = (id) => {
//createConnection().update('sujet',pro.sujet.id,data);
        if (movedRef.current) {
            console.log(stroke, lln);

            const data = stroke.point.map((c, i) => {
                const p = lln.segments[i]
                const pc = stroke.lineD[i]

                c.po = JSON.stringify([p.point.x, p.point.y, pc.pressure]);
                return c


            })

            data.map(c => {
                createConnection().update('point', c.id, c).then(ccc => {
                    console.log(ccc);
                })

            })

        } else {
            const data = {
                width: document.getElementById('wi').value, type: document.getElementById('typ').value
                , color: color
            };
            createConnection().update('strokes', id, data).then(ccc => {
                console.log(ccc);
            })
        }
    }
    const selStroke = (id) => {
// const pin=(document.getElementById('pin').value);
        const bou0 = document.getElementById('d').getBoundingClientRect();
        const bou = document.getElementById('p' + id).getBoundingClientRect();
        setRect(bou);
        setRect1(bou0);
    }
    const svgSel = (u, ev, ln = null) => {
        setStroke(null);
        setColor(u.color.replace(/ /g, ''));
        setLln(ln);
        setTimeout(() => {
            setStroke(u);
        }, 100);

    }
    const delStroke = (id) => {
        const delp = selectionRef.current.map(a => {

            createConnection().update('point', stroke.point[a[0]].id, {pu: true}).then(ccc => {
                console.log(ccc);
            })


        });


        return;
        if (confirm('sure delete this?')) {
            const lns = lines.filter(a => a.id != id);
            setLines(lns);
            console.log('delete from point where strokes=' + id + '; delete from strokes where id=' + id)
            // createConnection().delete('strokes', id).then(h => console.log(h));
        }

        //
    }
    return <>
    {loaded ? (<Test linesv={loaded}/>) : (<div className="p-4 w-full">
        {dia && (
            <>
                <div className="flex ">
                    <div id='d' ref={mydiv} className="bg-white"
                         style={{width: Math.floor(dia.ww) + "px", height: Math.floor(dia.hh) + "px"}}>
                        <div
                            className="canvas-select-wrap"
                            onPointerMove={handlePointerMove}
                            onPointerUp={handlePointerUp}
                            onPointerLeave={handlePointerUp}
                        >
                            <canvas ref={canvasRef}
                                    onPointerDown={handleCanvasPointerDown} id={"sa"} width={dia.ww}
                                    height={dia.hh}>


                            </canvas>

                            {selection && (
                                <div
                                    className="selection-rect"
                                    onPointerDown={handleSelectionPointerDown}
                                    style={{
                                        left: selection.x,
                                        top: selection.y,
                                        width: selection.width,
                                        height: selection.height,
                                    }}
                                >
                                    <div
                                        className="selection-handle bottom-right"
                                        onPointerDown={handleResizePointerDown}
                                    />
                                </div>
                            )}
                        </div>


                        <svg width={dia.ww} height={dia.hh} ref={svgF}>
                            <g transform={'translate(' + mat[1] + ',' + mat[2] + ')'}>
                                <g transform={'scale(' + mat[0] + ',' + mat[0] + ')'}>
                                    {
                                        gs.map((fg, i) => (
                                            <g id={fg[0].color} key={i}>

                                                {
                                                    fg.map((u, i) => (


                                                        <path key={u.id} id={'p' + u.id}
                                                              d={u.svg}
                                                              strokeWidth={1} fill="none" strokeLinecap="square"
                                                              stroke={u.color.replace('rgba', 'rgb').replace(',0.8)', ')')}/>


                                                    ))


                                                }
                                            </g>
                                        ))
                                    }

                                </g>

                            </g>
                            {rect && (<rect width={rect.width} height={rect.height} x={rect.x - rect1.x}
                                            y={rect.y - rect1.y} fill="blue" opacity='0.3'/>)}
                        </svg>
                        <button onClick={()=>downl()}>downl</button>
                    </div>

                    <div className="fixed p-2 bg-white " style={{right: '0px'}}>


                        {!stroke && (
                            <>
                                {dia.name}|{dia.id}|{dia.objet[0].id}
                                <div>
                                    <input defaultValue={dia.size} id="size"/>
                                    <button onClick={() => updd('size')}> sub</button>


                                </div>
                                <div>
                                    <input defaultValue={dia.name} id="name"/>
                                    <button onClick={() => updd('name')}> sub</button>


                                </div>
                                {stories && dia.story > 0 && (
                                    <>

                                        <select defaultValue={dia.story} onChange={(e) => {

                                            sele(e)
                                        }}>
                                            {stories && stories.map(t => (

                                                <option key={t.id} value={t.id}>{t.name} </option>


                                            ))


                                            }

                                        </select></>
                                )}


                                {dia.video && (
                                    <div>
                                        <button className="btn"
                                                onClick={() => updVid(dia.video.split('/').at(-1))}> delVideo
                                        </button>
                                    </div>
                                )}
                                {dia.thumb && (
                                    <div>
                                        <button className="button"
                                                onClick={() => upd({thumb: null, 'delete': dia.thumb})}> delThumb
                                        </button>
                                    </div>
                                )}
                                {story && (
                                    <button className="mt-4 button bg-succes-400">
                                        <Link to={'/' + story.name + '/' + dia.name}> sujet</Link>
                                    </button>
                                )}
                                <hr/>
                                {dia && dia.objet && (
                                    <button className="mt-4 button bg-gray-400"
                                            onClick={() => pub(dia.objet[0])}> get from clipboard
                                    </button>
                                )}

                                <br/>
                                <button className="mt-4 button bg-gray-400" onClick={() => se()}> zoom</button>
                                {dia.thumb && (
                                    <img src={dia.thumb} style={{width: '200px', height: 'auto'}} alt=""/>)}

                            </>
                        )}
                        {stroke && (
                            <>
                                <span onClick={() => setStroke(null)}> close</span>
                                <div className="bg-gray-50 p-4 mt-4">
                                    <div className=" p-1 ">{Number(stroke.id)}</div>
                                    <span onClick={() => box.current = 1}> box</span> <span
                                    onClick={() => box.current = 0}> unbox</span>
                                    <br/>
                                    w: <input className=" p-1  border" defaultValue={stroke.width} id="wi"/>
                                    <br/>
                                    <input className=" p-1 " defaultValue={stroke.type} id="typ"/>

                                    <RgbaStringColorPicker color={stroke.color} onChangeEnd={SetCool}/>
                                    <div className='flex'>
                                        {colors.map((c, i) => (

                                                <div key={i} className='m-2  ' onClick={() => {
                                                    setColor(c);
                                                    choose(c)
                                                }} style={{width: '24px', backgroundColor: c}}>&nbsp;</div>

                                            )
                                        )


                                        }
                                    </div>
                                    <div className='btn' onClick={() => choose()}>use</div>


                                    <br/>
                                    <button className=" m-2 " onClick={() => delStroke(stroke.id)}> del</button>


                                    <input id="pin" type="text"/>
                                    <br/>
                                    <button className=" m-2 " onClick={() => selStroke(stroke.id)}> sel</button>
                                    <button className=" m-2 " onClick={() => upStroke(stroke.id)}>update</button>
                                </div>
                            </>
                        )

                        }
                    </div>
                </div>
            </>
        )

        }


    </div>)}

        <style jsx>{`.canvas-select-wrap {
            position: relative;
            display: inline-block;
            overflow: hidden;
        }

        .canvas-select-wrap canvas {
            display: block;
        }

        .selection-rect {
            position: absolute;
            box-sizing: border-box;
            border: 2px dashed #2563eb;
            background: rgba(37, 99, 235, 0.12);
            cursor: move;
            z-index: 20;
        }

        .selection-handle {
            position: absolute;
            width: 12px;
            height: 12px;
            background: #2563eb;
            border: 2px solid white;
            box-sizing: border-box;
        }

        .selection-handle.bottom-right {
            right: -7px;
            bottom: -7px;
            cursor: nwse-resize;
        }`}</style>
    </>

}
export default MyForm;
